<script setup>
import { Bar } from 'vue-chartjs';
import 'chart.js/auto';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement } from 'chart.js';
import {onMounted, reactive, ref} from "vue";

import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement);
ChartJS.defaults.defaultFontFamily = 'Lato';
ChartJS.defaults.defaultFontSize = 18;
ChartJS.defaults.defaultFontColor = '#000';

const data = reactive({
  loaded: false,
  chartdata: {
    labels: [],
    datasets: [
      {
        // First line graph
        label: '90 day Avg',
        type: 'line',
        fill: false,
        data: [],
        backgroundColor: [
          '#FF5252',
          '#FF5252',
          '#FF5252',
          '#FF5252',
          '#FF5252',
          '#FF5252',
          '#FF5252',
        ],
        borderColor: ['#FF5252'],
        borderWidth: 3,
      },
      {
        // Second line graph
        label: '2 Week Avg',
        type: 'line',
        fill: false,
        data: [],
        backgroundColor: [
          '#4CAF50',
          '#4CAF50',
          '#4CAF50',
          '#4CAF50',
          '#4CAF50',
          '#4CAF50',
          '#4CAF50',
        ],
        borderColor: ['#4CAF50'],
        borderWidth: 3,
      },
      {
        // Bar graph - Placed after line charts so lines render over bars.
        label: 'Current Claims',
        type: 'bar',
        data: [],
        backgroundColor: [
          'rgba(25, 118, 210, 0.25)',
          'rgba(25, 118, 210, 0.25)',
          'rgba(25, 118, 210, 0.25)',
          'rgba(25, 118, 210, 0.25)',
          'rgba(25, 118, 210, 0.25)',
          'rgba(25, 118, 210, 0.25)',
          'rgba(25, 118, 210, 0.25)',
          // 'rgba(130, 177, 255, .5)',
          // 'rgba(130, 177, 255, .5)',
          // 'rgba(130, 177, 255, .5)',
          // 'rgba(130, 177, 255, .5)',
          // 'rgba(130, 177, 255, .5)',
        ],
        borderColor: [
          'rgb(25, 118, 210)',
          'rgb(25, 118, 210)',
          'rgb(25, 118, 210)',
          'rgb(25, 118, 210)',
          'rgb(25, 118, 210)',
          'rgb(25, 118, 210)',
          'rgb(25, 118, 210)',
          // 'rgb(130, 177, 255)',
          // 'rgb(130, 177, 255)',
          // 'rgb(130, 177, 255)',
          // 'rgb(130, 177, 255)',
          // 'rgb(130, 177, 255)',
        ],
        borderWidth: 1,
      },
    ],
  },
  options: {
    maintainAspectRatio: false,
    plugins:{
      title: {
        display: true,
        text: 'Current and Average Claims',
        fontSize: 25,
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: '#000',
        },
      },
    },
    elements: {
      point: {
        radius: 3,
      },
    },
    responsive: true,
    lineTension: 0.4,
    scales: {
      y:
          {
            ticks: {
              beginAtZero: true,
              padding: 25,
            },
          },
      x:
          {
            barPercentage: 0.9,
            categoryPercentage: 0.8,
            gridLines: {
              offsetGridLines: true,
            },
            offset: true,
          },
    },
  },
});

const getData = () =>{
  data.loaded = false;
  ApiWrapper.post('claims-chart', 'claims-chart', {})
      .then((response) => {
        let labels = []
        data.chartdata.labels = response.dowText;

        for(let x = response.finalAvgClaimsNinetyDays.length - 1; x >= 0; x--){
          data.chartdata.datasets[0].data.push(response.finalAvgClaimsNinetyDays[x].avg)
        }

        for(let x = response.finalAvgClaimsTwoWeeks.length - 1; x >= 0; x--){
          data.chartdata.datasets[1].data.push(response.finalAvgClaimsTwoWeeks[x].avg)
        }

        for(let x = response.finalClaims.length - 1; x >= 0; x--){
          data.chartdata.datasets[2].data.push(response.finalClaims[x].avg)
        }
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
      .finally(()=>{
        data.loaded=true;
      })
}

onMounted(() => {
  getData();
  // this.renderChart(data.chartdata, data.options);
});

</script>

<template>
  <v-container id="entreos-resize-target" fluid >
    <v-row>
      <v-col cols="12" class="pt-0 col">
        <v-card class="elevation-2" height="50vh" width="auto" v-if="data.loaded">
          <Bar :key="data.chartdata" :data="data.chartdata" :options="data.options" />
        </v-card>
        <v-card class="elevation-2" height="50vh" width="auto" v-else>
          <v-progress-linear
              color="primary"
              indeterminate
              absolute
          ></v-progress-linear>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>